<template>
  <div class="page">
    <navigation class="nav">推荐记录</navigation>
    <div class="container">
      <div class="banner">{{ maskPhoneNo }}</div>
      <div class="title">推荐明细</div>

      <ul class="share-list" v-if="detail.list && detail.list.length">
        <li v-for="(item, index) in detail.list" :key="index">
          <p class="phone">手机尾号 {{ item.lastNumber }}</p>
          <div class="list-content">
            <div v-for="(i, _i) in item.nodes" :key="_i" class="item">
              <i class="dot" v-if="_i !== 0"></i>
              <div class="item-info">
                <template v-if="i.node === 'REGISTER'">
                  <img src="./images/icon_zhuche@2x.png">
                  <span>注册成功</span>
                </template>

                <template v-if="i.node === 'DIVERSION'">
                  <img src="./images/icon_liulan@2x.png">
                  <span>浏览贡献达成</span>
                </template>

                <template v-if="i.node === 'WITHDRAW'">
                  <img src="./images/icon_tixian@2x.png">
                  <span>提现贡献达成</span>
                </template>

                <p v-if="i.dateTime">{{ i.dateTime | formatTime }}</p>
              </div>
            </div>
            <template v-if="item.nodes.length === 1">
              <div class="item">
                <i class="dot" v-if="_i !== 0"></i>
                <div class="item-info">
                  <img src="./images/icon_tixing@2x.png">
                  <span>提醒用户参与</span>
                </div>
              </div>
            </template>

          </div>
        </li>
      </ul>

      <div class="empty" v-else-if="!loading">
        <img src="./images/img_kong@2x.png" >
        <p>邀请新用户福利多多，请继续加油吧～</p>
      </div>

    </div>
    <img src="./images/loading@2x.png" v-if="loading" class="loading">
    <p class="bottom">&nbsp;</p>
    <p class="no-more" v-if="!hasNextPage && pageNum>2">没有更多内容了</p>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { mapActions } from 'vuex'
import { getKey } from '../../../assets/utils'
export default {
  data () {
    return {
      loading: !false,
      pageNum: 1,
      pageSize: 10,
      hasNextPage: true,
      detail: {
        list: []
      }
    }
  },
  computed: {
    userInfo () {
      return getKey('userInfo') || {}
    },
    maskPhoneNo () {
      const phone = this.userInfo.mobile
      return phone ? phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') : ''
    }
  },
  async mounted () {
    // 检测 bottom是否进入可视区域
    await this.getList()
    this.nextPageWatch()
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('share', ['OWNRecommendX']),
    // 滚动到底部
    nextPageWatch () {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && this.hasNextPage) {
            this.getList()
          }
        })
      })
      observer.observe(document.querySelector('.bottom'))
    },
    async getList () {
      clearTimeout(window.timer)
      window.timer = setTimeout(async () => {
        this.loading = true
        const { success, data } = await this.OWNRecommendX({
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        this.loading = false
        if (success && data.content?.length) {
          this.detail.list = [...this.detail.list, ...data.content]
          this.hasNextPage = data.hasNextPage
          this.pageNum++
        }
      }, 1000)
    }
  },
  filters: {
    formatTime (time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.page {
  background: #f7f7f7;
  min-height: 100vh;

 .no-more{
    text-align: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #999999;
    line-height: 33px;
    margin-top: 20px;
    padding-bottom: 30px;
  }
 
  .empty{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 140px;
    img {
      width: 408px;
      height: 250px;
    }
    p {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 26px;
      color: #999999;
      line-height: 36px;
      text-align: center;
      margin-top: 30px;
    }
  }

  @keyframes loading {
    to {
      transform: rotateZ(360deg);
    }
  }


  .loading {
    display: block;
    margin: 30px auto 0;
    animation: loading 1s infinite linear;
    filter:brightness(0.5);

  }


  .banner {
    width: 670px;
    height: 161px;
    background: url("./images/img_tuijianguan@2x.png") no-repeat center center/ 100% 100%;
    padding: 55px 30px;
    font-family: DIN, DIN;
    font-weight: 500;
    font-size: 44px;
    color: #ffffff;
    line-height: 53px;
  }

  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 38px;
    color: #333333;
    line-height: 53px;
    margin-top: 40px;
  }
  .dot {
    width: 35px;
    height: 9px;
    display: block;
    background: url('./images/img_diandian@2x.png') no-repeat;
    background-size: 100% 100%;
    margin-top: -50px;
    margin: -60px 10px 0;
  }
  .share-list {
    li {
      margin-top: 25px;
    }
    .list-content {
      display: flex;
      width: 670px;
      height: 180px;
      background: #ffffff;
      border-radius: 20px;
      padding: 30px;
    }
    .phone {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #333333;
      line-height: 33px;
      padding-bottom: 10px;
    }

    .item {
      display: flex;
      align-items: center;
    }

    .item-info {
      display: flex;
      flex-direction: column;
      height: 140px;
      align-items: center;
      span {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 26px;
          color: #333333;
          line-height: 37px;
          padding: 5px 0;
        }

        p {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 20px;
          color: #AAAAAA;
          line-height: 28px;
          text-align: center;
        }
      &>img {
        width: 60px;
        height: 60px;
      }
    }
  }

  .container {
    padding: 40px;
  }
}
</style>